import getEscapedRegExpText from '@/utils/getEscapedRegExpText';

/** @todo Probably we'll need to replace umlauts, nordic letters and such with similar latin chars to match Ä with A */
const getSearchRegExp = (text) => {
  const parts = typeof text === 'string' ? text.split(/[\s,]+/).filter(Boolean) : [];

  return new RegExp(parts.map(getEscapedRegExpText).join('|'), 'i');
};

export default getSearchRegExp;



// WEBPACK FOOTER //
// ./src/utils/getSearchRegExp.js